import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import ProductHeader from "../../Layout/Header/ProductHeader";
import { useTranslation } from "react-i18next";
import {
  Available,
  AvailableText,
  CustomerReviews,
  Faq,
  FormulatedByExperts,
  FreeShipping,
  HereMainHeading,
  OrderNow,
  SelectYourGoal,
  TailoredToYou,
  TailoredToYouDesc,
  TakeTheTestButton,
} from "../../Constants";
import useSmartFornula from "../../hooks/useSmartFormula";
import Tabs from "../Home/SmartFormulas/Tabs";
import SmartFormulaCarousel from "../Home/SmartFormulas/SmartFormulaCarousel";
import TickImg from "../../assets/FreeShippingTick.webp";
import Stars from "../../assets/stars-2.webp";
import useMeta from "../../hooks/useMeta";
import OneMonth from "../../assets/smart-formulas/one-month.webp";
import GiftImg from "../../assets/Gift.webp";
import SecureShippedVerifired from "../Home/SmartFormulas/SecureShippedVerifired";
import Ingredients from "../Home/SmartFormulas/Ingredients";
import ProductSuggestionWhyRiise from "../Customer/ProductSuggestionWhyRiise";
import CustomLink from "../CustomLink";
import VeganComponent from "../Home/Vegan";
import HowToEnjoy from "../Customer/components/HowToEnjoy";
import ExpertSection from "../Customer/components/ExpertSection";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../features/langSlice";
import HighStandards from "../Home/HighStandards";
import BoomTestimonials from "../Customer/components/BoomTestimonials";
import Reviews from "../Customer/components/Reviews";
import MakeChoice from "../Home/MakeChoice";
import HereForYou from "../Customer/components/HereForYou";

const Product = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const { SMART_FORMULAS } = useSmartFornula();
  const { metaEvent } = useMeta();
  const navigate = useNavigate();
  const selectedLang = useSelector(selectCurrentLanguage);

  if (!Object.keys(SMART_FORMULAS).includes(slug)) {
    return <Navigate to="/404" replace />;
  }

  return (
    <>
      <ProductHeader />
      <div className="container t-py-4">
        <div className="t-flex t-flex-col md:t-flex-row md:t-gap-4 t-items-start t-justify-start">
          <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-bold t-text-tertiary">
            {t(SelectYourGoal)}
          </h2>
          <Tabs
            data={SMART_FORMULAS}
            onClick={(item) => {
              console.log("onCLick");
              navigate(`/products/${item}`);
            }}
            activeFormula={slug}
            isProductPage
          />
        </div>
      </div>
      <div className="container">
        <div className=" t-mx-auto t-flex t-flex-col t-items-start t-justify-center md:t-flex-row t-gap-4 md:t-gap-12">
          <div className="t-w-full md:t-max-w-[500px]">
            <SmartFormulaCarousel
              images={SMART_FORMULAS[slug]?.images}
              isProductPage
            />
          </div>
          <div className="t-flex t-flex-col t-gap-4">
            <div className="t-flex t-flex-col">
              <h1>{SMART_FORMULAS[slug]?.heading}</h1>
              <div className={`t-flex t-items-center t-gap-2`}>
                <img src={Stars} alt="" height={80} width={80} />
                <p className="t-m-0 !t-font-bold">4.94/5 (80)</p>
              </div>
              <p className="t-m-0">{SMART_FORMULAS[slug]?.desc}</p>
            </div>
            <div className="t-flex t-flex-col t-gap-4">
              {SMART_FORMULAS[slug]?.benefits?.map((benefit) => (
                <div className="t-flex t-items-center t-gap-4">
                  <img
                    src={TickImg}
                    alt=""
                    className="t-flex-none t-w-5 t-h-5"
                  />
                  <p className="!t-m-0">{benefit.desc}</p>
                </div>
              ))}
            </div>
            <div className="t-flex t-flex-col t-gap-2 ">
              <div className="t-flex t-items-end t-justify-between">
                <div className="t-flex t-items-center gap-1">
                  <h1
                    className="t-text-secondary  !t-font-[900]"
                    style={{ fontFamily: "roboto" }}
                  >
                    {SMART_FORMULAS[slug]?.price}€
                  </h1>
                  <p className="t-m-0 t-text-gray-400">
                    ({(SMART_FORMULAS[slug]?.price / 30).toFixed(2)} €/portion)
                  </p>
                </div>
                <img src={OneMonth} alt="" className="t-h-16 t-ml-auto" />
              </div>
              <div className="t-flex t-items-center t-justify-start t-gap-2 !-t-mt-4">
                <img src={GiftImg} alt="" className="t-h-4 t-w-4" />
                <p className="!t-m-0">{t(FreeShipping)}</p>
              </div>
              <button
                onClick={async () => {
                  metaEvent("InitiateCheckout");
                  window.location.href = `${SMART_FORMULAS[slug]?.link}?client_reference_id=${slug}`;
                }}
                className="!t-text-sm !t-text-capitalize btn-custom-quaternary !t-py-2 !t-bg-secondary disabled:!t-bg-secondary hover:!t-text-white disabled:t-opacity-50 !t-rounded-lg"
              >
                Buy Now
              </button>
            </div>
            <div className="t-flex t-items-start t-gap-1 t-flex-row">
              <div className="t-flex-none t-w-3 t-h-3 t-bg-green-400 t-mt-[5px] t-rounded-full" />
              <p className="t-text-sm t-m-0 t-text-green-400 !t-font-bold">
                {t(Available)}&nbsp;
                <span
                  className="t-text-sm t-mt-0 t-text-black t-font-extrabold"
                  style={{ fontFamily: "roboto" }}
                >
                  - {t(OrderNow)}
                </span>
                <span className="t-text-sm t-mt-0 t-text-black">
                  {t(AvailableText)}
                </span>
              </p>
            </div>
            <SecureShippedVerifired />
            <div className="t-flex t-flex-col t-gap-2">
              <Ingredients ingredients={SMART_FORMULAS[slug]?.ingredients} />
              <ProductSuggestionWhyRiise viewHalf />
            </div>
          </div>
        </div>
      </div>
      <div className="t-flex t-flex-col t-gap-8 t-bg-gray-100 t-px-4 t-py-8">
        <div className="t-w-full t-max-w-[800px] t-mx-auto t-flex t-flex-col t-gap-8">
          <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-bold t-text-tertiary">
            {t(TailoredToYou)}
          </h2>
          <p className="!t-m-0 t-text-center">{t(TailoredToYouDesc)}</p>
          <CustomLink
            to="/quiz"
            className="!t-w-full t-max-w-[300px] t-mx-auto"
          >
            <span className="!t-w-full btn btn-custom-secondary !t-rounded-lg">
              {t(TakeTheTestButton)}
            </span>
          </CustomLink>
        </div>
      </div>
      <VeganComponent whiteBg />
      <div className="t-w-full t-max-w-[500px] t-mx-auto ">
        <HowToEnjoy
          className="!t-max-h-[400px] !t-max-w-[400px] t-mx-auto"
          isProductPage
        />
      </div>
      <div className="t-max-w-[800px] t-mx-auto t-flex t-flex-col t-gap-4 t-overflow-auto t-mt-8">
        <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-bold t-text-tertiary">
          {t(FormulatedByExperts)}
        </h2>
        <ExpertSection lang={selectedLang === "us" ? "en" : selectedLang} />
      </div>
      <HighStandards />
      <div className="container !t-max-w-[1100px] t-mx-auto t-flex t-flex-col t-gap-4 t-overflow-auto t-my-8">
        <BoomTestimonials />
      </div>
      <div className="t-bg-gray-100 t-pt-4">
        <div className="container t-bg-gray-100 t-flex t-flex-col t-gap-4 t-overflow-auto t-mt-4 md:t-min-h-[495px]">
          <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-bold t-text-tertiary">
            {t(CustomerReviews)}
          </h2>
          <Reviews />
        </div>
      </div>
      <div className="t-w-full !t-max-w-[600px] t-mx-auto container t-flex t-flex-col t-gap-4 md:t-min-h-[464px]">
        <MakeChoice isProductPage />
      </div>
      <div className="container !t-max-w-[600px] t-flex t-flex-col t-gap-4 !t-my-8">
        <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-bold t-text-tertiary">
          {t(Faq)}
        </h2>
        <ProductSuggestionWhyRiise viewOtherHalf />
      </div>
      <section className="steps section-padding t-max-w-[700px] t-mx-auto !t-pb-8 !t-bg-white t-h-[400px] md:t-h-[412px] !t-px-4">
        <div className="t-mb-8">
          <h3 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-bold t-text-tertiary">
            {t(HereMainHeading)}
          </h3>
        </div>

        <HereForYou />
      </section>
    </>
  );
};

export default Product;
